// Store du Dashboard YT (Social). Les filtres s'appliquent à toute la page ;
// `filtersVersion` s'incrémente à chaque changement et chaque onglet recharge
// ses données quand il est visible et que sa version est en retard.

export const DEFAULT_PERIOD = '28'
export const DEFAULT_AGE = 'all'

const DEFAULT_STATE = {
  period: DEFAULT_PERIOD,
  customFrom: null,
  customTo: null,
  siteGroupId: null,
  siteId: null,
  age: DEFAULT_AGE,
  topMetric: 'views',
  options: null,
  overview: null,
  filtersVersion: 0,
}

export default {
  namespaced: true,

  state: { ...DEFAULT_STATE },

  getters: {
    getPeriod: (state) => state.period,
    getCustomFrom: (state) => state.customFrom,
    getCustomTo: (state) => state.customTo,
    getSiteGroupId: (state) => state.siteGroupId,
    getSiteId: (state) => state.siteId,
    getAge: (state) => state.age,
    getTopMetric: (state) => state.topMetric,
    getOptions: (state) => state.options,
    getOverview: (state) => state.overview,
    getFiltersVersion: (state) => state.filtersVersion,
    getLastDate: (state) => state.options?.last_date || null,
    getSites: (state) => {
      const sites = state.options?.sites || []
      if (!state.siteGroupId) return sites
      const group = (state.options?.site_groups || []).find((g) => g.id === state.siteGroupId)
      const allowed = new Set(group?.site_ids || [])
      return sites.filter((site) => allowed.has(site.id))
    },
  },

  mutations: {
    setPeriod(state, period) { state.period = period },
    setCustomRange(state, { from, to }) { state.customFrom = from; state.customTo = to },
    setSiteGroupId(state, id) { state.siteGroupId = id },
    setSiteId(state, id) { state.siteId = id },
    setAge(state, age) { state.age = age },
    setTopMetric(state, metric) { state.topMetric = metric },
    setOptions(state, options) { state.options = options },
    setOverview(state, overview) { state.overview = overview },
    bumpFiltersVersion(state) { state.filtersVersion += 1 },
  },

  actions: {
    updatePeriod({ commit }, period) {
      commit('setPeriod', period)
      if (period !== 'custom') commit('bumpFiltersVersion')
    },
    updateCustomRange({ commit }, range) {
      commit('setCustomRange', range)
      commit('setPeriod', 'custom')
      commit('bumpFiltersVersion')
    },
    updateSiteGroup({ commit, state, getters }, id) {
      commit('setSiteGroupId', id || null)
      if (state.siteId && !getters.getSites.some((site) => site.id === state.siteId)) {
        commit('setSiteId', null)
      }
      commit('bumpFiltersVersion')
    },
    updateSite({ commit }, id) {
      commit('setSiteId', id || null)
      commit('bumpFiltersVersion')
    },
    updateAge({ commit }, age) {
      commit('setAge', age)
      commit('bumpFiltersVersion')
    },
    updateTopMetric({ commit }, metric) {
      commit('setTopMetric', metric)
    },
    resetFilters({ commit }) {
      commit('setPeriod', DEFAULT_PERIOD)
      commit('setCustomRange', { from: null, to: null })
      commit('setSiteGroupId', null)
      commit('setSiteId', null)
      commit('setAge', DEFAULT_AGE)
      commit('bumpFiltersVersion')
    },
  },
}
